<div class="queue-overview-header-bar">
  <div class="queueoverview-navbar-header"></div>
  <span *ngIf="branchData">{{ branchData?.attributes?.name }}</span>
</div>

<div class="main-flex-container {{ queues?.length > 4 ? '--gt-4' : '' }}">
  <ng-container *ngFor="let queue of queues; let i = index">
    <div class="queue-column --{{ queue.integrationType }}">
      <div class="queue-title">
        <div class="queue-count"><i class="queue-icon"></i>{{ queue?.tokens?.length }}</div>
        <span class="queue-name">{{ queue.name }} </span>
        <button
          *ngIf="mutedQueues.includes(queue.id)"
          type="button"
          class="icon-button volume-off-icon"
          aria-label="Unmute queue {{ queue.name }}"
          (click)="muteQueue(queue.id)"
        ></button>
        <button
          *ngIf="!mutedQueues.includes(queue.id)"
          type="button"
          class="icon-button volume-on-icon"
          aria-label="Mute queue {{ queue.name }}"
          (click)="muteQueue(queue.id)"
        ></button>
      </div>

      <ng-container [ngSwitch]="queue.integrationType">
        <!-- helseboka_booking -->
        <div class="booking-list" *ngSwitchCase="'helseboka_booking'">
          <div class="booking --{{ booking.status }}" [@tokenAnimation] *ngFor="let booking of queue.bookings">
            <div
              [ngClass]="{
                'queue-no': true,
                '--no-token': !booking.tokenNumber,
                '--served': booking.status === 'served',
                '--no_show': booking.status === 'no_show'
              }"
            >
              {{ booking.tokenNumber || '' }}
            </div>
            <div>
              <div class="booking-time">{{ booking.bookingDate }}</div>
              <div class="booking-status --{{ booking.status }}" [ngSwitch]="booking.status">
                <ng-container *ngSwitchCase="'pending'">Ankommet</ng-container>
                <ng-container *ngSwitchCase="'token_generated'">Ankommet <i class="check-icon"></i></ng-container>
                <ng-container *ngSwitchCase="'cancelled'">Kansellert</ng-container>
                <ng-container *ngSwitchDefault>Ferdig</ng-container>
              </div>
            </div>
          </div>
        </div>

        <!-- default -->
        <div class="queue-list-wrapper" *ngSwitchDefault>
          <div class="token" [@tokenAnimation] *ngFor="let token of queue.tokens">
            <div class="queue-no">{{ token.tokenNumber }}</div>
            <div class="wait-time">{{ token.waitTime | readableTime }}</div>
            <div class="wait-time-indicator {{ token.mood }}-cls"></div>
          </div>
        </div>
      </ng-container>

      <div *ngIf="!!queue?.integrationType" class="queue-overview-footer --{{ queue.integrationType }}">
        <i></i>
      </div>
    </div>
  </ng-container>
</div>
